/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortalEmailAvailabilityResponse
 */
export interface PortalEmailAvailabilityResponse {
    /**
     * 
     * @type {boolean}
     * @memberof PortalEmailAvailabilityResponse
     */
    portalAccountExists: boolean;
    /**
     * 
     * @type {string}
     * @memberof PortalEmailAvailabilityResponse
     */
    linkedClientId: string | null;
    /**
     * 
     * @type {string}
     * @memberof PortalEmailAvailabilityResponse
     */
    linkedClientName: string | null;
    /**
     * 
     * @type {string}
     * @memberof PortalEmailAvailabilityResponse
     */
    linkedCaseNumber: string | null;
}

/**
 * Check if a given object implements the PortalEmailAvailabilityResponse interface.
 */
export function instanceOfPortalEmailAvailabilityResponse(value: object): value is PortalEmailAvailabilityResponse {
    if (!('portalAccountExists' in value) || value['portalAccountExists'] === undefined) return false;
    if (!('linkedClientId' in value) || value['linkedClientId'] === undefined) return false;
    if (!('linkedClientName' in value) || value['linkedClientName'] === undefined) return false;
    if (!('linkedCaseNumber' in value) || value['linkedCaseNumber'] === undefined) return false;
    return true;
}

export function PortalEmailAvailabilityResponseFromJSON(json: any): PortalEmailAvailabilityResponse {
    return PortalEmailAvailabilityResponseFromJSONTyped(json, false);
}

export function PortalEmailAvailabilityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalEmailAvailabilityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'portalAccountExists': json['portalAccountExists'],
        'linkedClientId': json['linkedClientId'],
        'linkedClientName': json['linkedClientName'],
        'linkedCaseNumber': json['linkedCaseNumber'],
    };
}

export function PortalEmailAvailabilityResponseToJSON(json: any): PortalEmailAvailabilityResponse {
    return PortalEmailAvailabilityResponseToJSONTyped(json, false);
}

export function PortalEmailAvailabilityResponseToJSONTyped(value?: PortalEmailAvailabilityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'portalAccountExists': value['portalAccountExists'],
        'linkedClientId': value['linkedClientId'],
        'linkedClientName': value['linkedClientName'],
        'linkedCaseNumber': value['linkedCaseNumber'],
    };
}

